<!--
 * @Description  : 开票
 * @Author       : zl
 * @Date         : 2024-07-18 10:07:38
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-12 16:14:50
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\invoice\invoice-history.vue
-->
<template>
	<div class="h100 invoice-history">
	  <filter-layout @search="searchResult" @reset="reset" v-if="!routeQuery" hasHeader>
		<template #header>
		  <el-tabs v-model="activeName" @tab-click="tabClick">
			<el-tab-pane label="待开票" name="0"> </el-tab-pane>
			<el-tab-pane label="已开票" name="1"> </el-tab-pane>
		  </el-tabs>
		</template>
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="流水号：" prop="orderId">
			  <el-input
				v-model="searchForm.orderId"
				placeholder="请输入流水号"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="纳税人名称(销方)：" prop="taxPayNameDem" label-width="150px">
			  <el-input
				v-model="searchForm.taxPayNameDem"
				placeholder="请输入纳税人名称(销方)"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="纳税人名称(购方)：" prop="taxPayNameBuy" label-width="150px">
			  <el-input
				v-model="searchForm.taxPayNameBuy"
				placeholder="请输入纳税人名称(购方)"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="商品名称：" prop="proName" label-width="90px">
			  <el-input
				v-model="searchForm.proName"
				placeholder="请输入商品名称"
				size="small"
			  ></el-input>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title"></div>
			<div class="btnGroups">
			  <el-button
				type="primary"
				class="ml5 btn-blue"
				size="mini"
				@click="reset"
			  >
				<i class="el-icon-refresh"></i>
			  </el-button>
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow" ref="table">
			  <vxe-table
				ref="xTable"
				auto-resize
				resizable
				border
				size="small"
				:data="tableData"
				highlight-current-row
				highlight-hover-row
				height="100%"
				:loading="loading"
				show-overflow="tooltip"
				show-header-overflow="tooltip"
			  >
				<vxe-table-column
				  type="seq"
				  width="55px"
				  title="序号"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="serialNo"
				  title="流水号"
				  min-width="160px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="taxPayNameDem"
				  title="纳税人名称(销方)"
				  min-width="200px"
				  header-align="center"
				>
				</vxe-table-column>
				<vxe-table-column
				  field="taxPayNameBuy"
				  title="纳税人名称(购方)"
				  min-width="200px"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="totalMoney"
				  title="开票金额 (元)"
				  min-width="120px"
				  header-align="center"
				  align="right"
				>
				  <template v-slot="{ row }">
					{{
					  row.totalMoney != null
						? parseFloat(row.totalMoney).toFixed(2)
						: ""
					}}
				  </template>
				</vxe-table-column>
				<vxe-table-column
				  field="proName"
				  title="商品名称"
				  align="center"
				  min-width="165px"
				></vxe-table-column>
				<vxe-table-column
				  field="typeCodeName"
				  title="发票类型"
				  align="center"
				  min-width="140px"
				></vxe-table-column>

				<vxe-table-column
				  field="createDate"
				  title="申请时间"
				  width="150px"
				  align="center"
				  v-if="activeName == '0'"
				></vxe-table-column>

				<vxe-table-column
				  field="invoiceNo"
				  title="发票号码"
				  v-if="activeName == '1'"
				  align="center"
				  width="150px"
				></vxe-table-column>
				<vxe-table-column
				  field="issueTimeDate"
				  title="开票日期"
				  v-if="activeName == '1'"
				  align="center"
				  width="150px"
				></vxe-table-column>

				<vxe-table-column
				  field="status"
				  title="开票状态"
				  width="120px"
				  align="center"
				>
				  <template v-slot="{ row }">
					<span class="gray-state" v-if="row.status == -1">待开票</span>
					<span class="orange-state" v-else-if="row.status == 0"
					  >开票中</span
					>
					<span
					  class="green-state"
					  v-else-if="row.status == 1 && activeName == 0"
					  >开票成功</span
					>
					<span class="red-state" v-else-if="row.status == 2"
					  >开票失败</span
					>
					<span
					  class="gray-state"
					  v-else-if="row.status == 1 && activeName == 1"
					  >已开票</span
					>
					<span class="orange-state" v-else-if="row.status == 3"
					  >红冲申请中</span
					>
					<span class="blue-state" v-else-if="row.status == 4"
					  >红冲成功</span
					>
					<span class="red-state" v-else-if="row.status == 5"
					  >红冲失败</span
					>
				  </template>
				</vxe-table-column>

				<vxe-table-column
				  title="操作"
				  :min-width="activeName == '1' ? '350px' : '180px'"
				  align="left"
				>
				  <template v-slot="{ row }">
					<el-button
					  type="primary"
					  round
					  plain
					  class="table-btn"
					  :disabled="row.status == 0"
					  v-if="
						roleBtns.includes('checkInvoice') && activeName == '1'
					  "
					  @click="handleView(row)"
					>
					  <svg-icon icon-class="form-invoice"></svg-icon> 查看发票
					</el-button>
					<el-button
					  type="primary"
					  round
					  plain
					  class="table-btn"
					  v-if="roleBtns.includes('invoiceDetail')"
					  @click="detail(row, 'view')"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
					<!-- 只有能工社包年是1010001,并且待开票或者 开票失败才显示开票按钮 -->
					<el-button type="primary" round plain class="table-btn"
					  v-if="roleBtns.includes('makeInvoice') && activeName == '0' && (row.status == -1 || row.status == 2)
					  && row.busType != '1010001' && row.busType != '1010002' && row.busType != '1010003'" @click="makeInvoice(row)">
					  <svg-icon icon-class="makeInvoice"></svg-icon> 开票 </el-button>
					<!-- 开票状态为未红冲 和 红冲失败才有红冲按钮 -->
					<el-button type="primary" round plain class="table-btn"
					  v-if="roleBtns.includes('redInvoice') && activeName == '1' && (row.status == 1 || row.status == 5) && row.isLine == 0 && row.busType != '1010002' && row.busType != '1010003'" @click="redInvoice(row, 'add')">
					  <svg-icon icon-class="redInvoice"></svg-icon> 红冲 </el-button>
					<!-- 红冲成功显示红冲详情 -->
					<el-button
					  type="primary"
					  round
					  plain
					  class="table-btn"
					  v-if="
						roleBtns.includes('invoice-details') &&
						activeName == '1' &&
						row.status == 4
					  "
					  @click="detail(row, 'red')"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 红冲详情
					</el-button>
				  </template>
				</vxe-table-column>
			  </vxe-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="tablePage.currentPage"
				:page-size="tablePage.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tablePage.total"
			  >
			  </el-pagination>
			</div>
		  </div>
		  <!-- 查看发票接口 -->
		  <el-dialog
			center
			:close-on-click-modal="false"
			title="查看发票"
			:visible.sync="viewInvoice"
			width="1000px"
		  >
			<iframe
			  name="invoice"
			  class="w100"
			  frameborder="0"
			  :src="viewSrc"
			  height="600px"
			  scrolling="no"
			/>
		  </el-dialog>

		  <!-- 红冲 -->
		  <el-dialog
			:before-close="dialogClose"
			:close-on-click-modal="false"
			:destory-on-close="true"
			title="红冲"
			align="center"
			:visible.sync="dialogObj.show"
			width="800px"
		  >
			<div class="mb20 ml30 title-style">
			  红冲后，之前发票不可使用，用户可以再次申请开票！
			</div>
			<el-form
			  :model="redForm"
			  ref="redForm"
			  label-width="80px"
			  size="small"
			>
			  <el-form-item
				label="红冲原因"
				prop="reason"
				:rules="[
				  { required: true, message: '不能为空...', trigger: 'change' },
				]"
			  >
				<el-select v-model="redForm.reason" clearable disabled>
				  <el-option label="开票有误" :value="1"></el-option>
				  <!-- <el-option label="销货退回" :value="2"></el-option>
						  <el-option label="服务终止" :value="3"></el-option>
						  <el-option label="销售折让" :value="4"></el-option> -->
				</el-select>
			  </el-form-item>
			  <el-form-item label="价税合计" prop="amount">
				<el-input v-model="redForm.amount" disabled> </el-input>
			  </el-form-item>
			</el-form>

			<div slot="footer" class="text-center">
			  <el-button class="btn" @click="dialogClose">取 消</el-button>
			  <el-button
				class="btn btn-blue"
				type="primary"
				@click="dialogSubmit"
				:loading="dialogObj.loading"
				>确 定</el-button
			  >
			</div>
		  </el-dialog>

		  <!-- 开票 -->
		  <el-dialog
			:before-close="kpDialogClose"
			:close-on-click-modal="false"
			:destory-on-close="true"
			:title="kpDialogObj.title"
			align="center"
			:visible.sync="kpDialogObj.show"
			width="1000px"
		  >
			<el-form
			  :model="invoiceForm"
			  ref="invoiceForm"
			  label-width="100px"
			  size="small"
			>
			  <el-row :gutter="20">
				<el-col :span="12">
				  <el-form-item
					label="发票号"
					:prop="kpDialogObj.mode == 'view' ? '' : 'invoiceNo'"
					:rules="invoiceNoRule"
				  >
					<el-input
					  v-model="invoiceForm.invoiceNo"
					  placeholder="请输入发票号"
					  maxlength="30"
					  show-word-limit
					  clearable
					  :disabled="kpDialogObj.mode == 'view'"
					>
					</el-input>
				  </el-form-item>
				</el-col>
				<el-col :span="12">
				  <el-form-item
					label="开票日期"
					:prop="kpDialogObj.mode == 'view' ? '' : 'issueTime'"
					:rules="[
					  {
						required: true,
						message: '不能为空...',
						trigger: 'change',
					  },
					]"
				  >
					<el-date-picker
					  v-model="invoiceForm.issueTime"
					  type="date"
					  size="small"
					  value-format="yyyy-MM-dd"
					  placeholder="请输入开票日期"
					  :disabled="kpDialogObj.mode == 'view'"
					>
					</el-date-picker>
				  </el-form-item>
				</el-col>
				<el-col :span="24">
				  <el-form-item
					label="发票类型"
					:prop="kpDialogObj.mode == 'view' ? '' : 'typeCode'"
					class="text-left"
					:rules="[
					  {
						required: true,
						message: '请选择发票类型',
						trigger: 'change',
					  },
					]"
				  >
					<el-radio-group v-model="invoiceForm.typeCode">
					  <el-radio label="01">数电发票（专票）</el-radio>
					  <el-radio label="02">数电发票（普票）</el-radio>
					</el-radio-group>
				  </el-form-item>
				</el-col>
				<el-col :span="24">
				  <el-form-item label="发票附件">
					<template slot="label">
					  <span class="red-color" v-if="kpDialogObj.mode == 'add'"
						>*</span
					  >发票附件
					</template>
					<public-upload
					  ref="upload"
					  tableName="operate_invoice_record"
					  assortment="invoice_file"
					  forDatabase="invoice"
					  :aid="invoiceForm.id"
					  :needRefresh="false"
					  :maxNum="3"
					  :showSizeTip="true"
					  :showLengthTip="true"
					  :fileSize="50"
					  :isViewMode="isViewMode"
					  :viewFilesList="viewFilesList"
					></public-upload>
				  </el-form-item>
				</el-col>
			  </el-row>
			</el-form>

			<div
			  slot="footer"
			  class="text-center"
			  v-if="kpDialogObj.mode == 'add'"
			>
			  <el-button class="btn" @click="kpDialogClose">取 消</el-button>
			  <el-button
				class="btn btn-blue"
				type="primary"
				@click="kpDialogSubmit"
				:loading="kpDialogObj.loading"
				>确 定</el-button
			  >
			</div>
		  </el-dialog>
		</template>
	  </filter-layout>
	  <div v-else class="h100 invoice-history operation-layout y-auto">
		<history-detail :detailId="detailId"></history-detail>
	  </div>
	</div>
  </template>
<script>
import {
	applyRedInkInvoice,
	getCheckEleInvoice,
	getInvoiceInfoRecordList,
	physicalInvoice,
	physicalInvoiceDetail,
	reissueInvoice,
} from "api/modules/invoice";
import axios from "axios";
import { Snowflake } from "node-snowflake";
import { mapState } from "vuex";

import historyDetail from "./history-detail.vue";

export default {
	name: 'Pay-money',
	props: {},
	components: {
		historyDetail
	},
	data() {
		return {
			searchForm: {
				paySerial: '', //流水号
				status: '', //开票状态
				taxPayNameDem: '', //纳税人名称(销方)
				taxPayNoDem: '', //纳税人识别号(销方)
				taxPayNameBuy: '', //纳税人名称(购方)
				proName: '', // 商品名称
				invoiceCode: '', //发票代码
				invoiceNo: '', //发票号码
				startDate: '', //开始时间
				endDate: '', //结束时间
				ticketType: '', //票类型
				tabType: '0' //tab类型
			},
			tableData: [],
			tablePage: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			loading: false,
			searchToggle: true,
			tableShow: true,
			activeName: '0',
			isShow: 0,
			detailId: '',
			viewInvoice: false,
			viewSrc: '',
			invoiceObj: {},
			viewFpdm: '',
			viewFphm: '',

			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),
			dialogObj: {
				show: false,
				loading: false
			},
			redForm: {
				reason: 1, //红冲原因
				amount: '' //价税合计
			},
			kpDialogObj: {
				show: false,
				loading: false,
				mode: 'add',
				title: '开票'
			},
			invoiceForm: {
				id: '', // 作为文件id
				invoiceNo: '', //发票号码
				issueTime: '', //开票日期
				typeCode: '' // 发票类型
			},
			invoiceNoRule: [
				{
					required: true,
					message: '发票号不能为空...',
					trigger: ['blur', 'change']
				},
				{ pattern: /^[0-9]{0,30}$/, message: '请输入数字' }
			],
			viewFilesList: [], // 查看文件列表
			isViewMode: false // 文件是否是查看模式
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('invoiceHistory')) {
				this.searchForm = JSON.parse(this.$getSessionItem('invoiceHistory'))
				this.tablePage.currentPage = JSON.parse(this.$getSessionItem('invoiceHistory')).currentPage
				this.tablePage.pageSize = JSON.parse(this.$getSessionItem('invoiceHistory')).pageSize

				this.activeName = JSON.parse(this.$getSessionItem('invoiceHistory')).tabType
				this.$removeSessionItem('invoiceHistory')
			}
		}

		this.getInvoiceInfoRecordList()
	},
	methods: {
		// 获取所有的开票记录
		getInvoiceInfoRecordList() {
			this.loading = true
			let params = Object.assign({}, this.searchForm)
			params.current = this.tablePage.currentPage
			params.size = this.tablePage.pageSize
			getInvoiceInfoRecordList(params)
				.then((d) => {
					if (d.operationCode == 1) {
						this.tableData = d.data.records
						this.tablePage.total = parseInt(d.data.total)
						this.loading = false
					}
				})
				.catch((error) => {
					this.loading = false
				})
		},

		// 搜索
		searchResult() {
			this.tablePage.currentPage = 1
			this.getInvoiceInfoRecordList()
		},

		// 重置
		reset() {
			this.searchForm.endDate = ''
			this.$refs.searchRef.resetFields()
			this.searchResult()
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tablePage.pageSize = size
			this.getInvoiceInfoRecordList()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tablePage.currentPage = cur
			this.getInvoiceInfoRecordList()
		},

		// tab点击事件
		tabClick({ name }) {
			// tab类型赋值
			this.searchForm.tabType = name
			// 调取列表接口
			this.searchResult()
		},

		// 查看详情
		handleView(data) {
			// 线上开票
			if (data.isLine == 0) {
				this.viewInvoice = true
				this.invoiceObj = data

				// 如果是红冲成功的，获取红冲的发票信息
				getCheckEleInvoice({
					id: data.status == 4 ? data.redInkId : data.id
				}).then((d) => {
					if (d.data.code == 0) {
						if (d.data.ddlsh) {
							this.viewSrc = d.data.fpurl
						} else {
							this.viewSrc = d.data.fpurl.includes('https') ? d.data.fpurl : d.data.fpurl.replace(/http/i, 'https')
						}
						this.viewFpdm = d.data.fpdm
						this.viewFphm = d.data.fphm
					} else {
						this.$message.error(d.data.msg)
					}
				})
			} else if (data.isLine == 1) {
				// 如果状态为待开票的，填写表单
				this.kpDialogObj.show = true

				// 弹框模式赋值
				this.kpDialogObj.mode = 'view'

				this.kpDialogObj.title = '查看详情'

				physicalInvoiceDetail({
					id: data.id
				}).then((res) => {
					let data = res.data
					this.invoiceForm.invoiceNo = data.invoiceNo
					this.invoiceForm.issueTime = data.issueTime ? data.issueTime.slice(0, 10) : ''
					this.invoiceForm.typeCode = data.typeCode || ''
					// 文件查看模式
					this.isViewMode = true
					this.viewFilesList = data.fileList
				})
			}
		},

		// 记录详情
		detail(data, type) {
			// 根据类型赋值id，红冲详情以redInkId为id
			this.detailId = type == 'red' ? data.redInkId : data.id

			let params = Object.assign({}, this.searchForm)
			params.pageSize = this.tablePage.pageSize
			params.currentPage = this.tablePage.currentPage

			// 存值
			this.$setSessionItem('invoiceHistory', JSON.stringify(params))

			this.$router.push({
				path: '/invoice-history',
				query: {
					type: 'detail'
				}
			})
		},

		// 开票
		async makeInvoice(data) {
			// 如果是状态为开票失败的，进行弹框提示再处理
			if (data.status == 2) {
				this.$confirm('申请开票后无法撤回，是否确定开票？', '提醒', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						reissueInvoice({
							id: data.id
						}).then((d) => {
							this.$message.success('已提交申请')
							// 刷新查询列表
							this.searchResult()
						})
					})
					.catch(() => {
						this.$message.error('已取消')
					})
			} else if (data.status == -1) {
				// 如果状态为待开票的，填写表单
				this.kpDialogObj.show = true

				// 弹框模式赋值
				this.kpDialogObj.mode = 'add'

				// 弹框标题赋值
				this.kpDialogObj.title = '开票'

				// 开票id赋值
				this.invoiceForm.id = data.id

				// 数据清空
				this.invoiceForm.invoiceNo = ''
				this.invoiceForm.issueTime = ''
				this.invoiceForm.typeCode = ''

				// 文件是编辑模式
				this.isViewMode = false

				this.viewFilesList = []
			}
		},

		// 红冲
		redInvoice(data) {
			this.dialogObj.show = true
			// 赋值
			this.redForm.reason = 1
			// id赋值
			this.redForm.id = data.id
			this.redForm.redId = data.redInkId
			// 税价赋值
			this.redForm.amount = data.totalMoney != null ? -parseFloat(data.totalMoney).toFixed(2) : ''
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchForm.endDate
					if (endTime) {
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateBefore(time, endTime, false)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchForm.startDate
					if (startTime) {
						let nowTime = Date.now()
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, false)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 弹窗关闭
		dialogClose() {
			this.dialogObj.loading = false
			this.dialogObj.show = false
		},

		// 弹窗确定
		dialogSubmit() {
			this.$refs.redForm.validate((valid) => {
				if (valid) {
					applyRedInkInvoice({ id: this.redForm.id, redId: this.redForm.redId }).then((d) => {
						this.$message.success('红冲申请成功')
						// 关闭弹框
						this.dialogClose()
						// 刷新列表
						this.searchResult()
					})
					return
				}
				this.$message.error('请完善表单')
			})
		},

		// 开票弹窗关闭
		kpDialogClose() {
			this.$refs.invoiceForm.resetFields()
			this.$refs.upload.fileList = []
			this.$refs.upload.addList = []
			this.kpDialogObj.loading = false
			this.kpDialogObj.show = false
		},

		// 开票弹窗确定
		kpDialogSubmit() {
			this.$refs.invoiceForm.validate((valid) => {
				if (valid) {
					let fileLength = this.$refs.upload.addList.length === 0 && this.$refs.upload.fileList.length === 0
					if (fileLength) {
						this.$message.error('请上传附件！')
						return
					}
					let params = Object.assign({}, this.invoiceForm)

					physicalInvoice(params).then((d) => {
						this.$message.success('开票成功')

						this.$refs.upload.fileSend(this.invoiceForm.id)

						// 关闭弹框
						this.kpDialogClose()

						// 刷新列表
						this.searchResult()
					})
				} else {
					this.$message.error('请完善表单')
				}
			})
		},

		// 上传到服务器
		uploadToService(id) {
			this.$refs.upload.fileSend(id)
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', {
			isBack: (state) => state.isBack
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
	// destroyed(){
	// 	if(!this.isBack){
	// 		this.$removeSessionItem('invoiceHistory')
	// 	}
	// }
}
</script>
<style lang="less" scoped>
.invoice-history {
	.searchForm {
		/deep/ .el-form-item {
			margin-bottom: 10px;
		}
	}
	.content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		.title {
		  padding-left: 10px;
		  border-left: 4px solid #2671cc;
		  font-size: 14px;
		  color: #202020;
		}
		.blue{
		  font-size: 18px;
		  color: #2671cc;
		}
	  }
	.btn-style {
		width: 80px;
		height: 32px;
	}

	.operation-header {
		display: block;
		line-height: 40px;

		.number-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.number {
				padding-left: 10px;
				border-left: 4px solid #2671cc;
				height: 30px;
				line-height: 30px;

				span {
					color: #2671cc;
					font-size: 18px;
				}
			}
		}
	}

	.operation-container {
		height: 100%;
	}

	/deep/ .vxe-cell--title {
		color: #202020;
		font-weight: normal;
	}

	.giveup {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.giveup::before {
		content: '';
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		border-radius: 50%;
		background-color: #ffff00;
		box-shadow: 0px 0px 4px 0px #ffff00;
	}

	.ml0 {
		margin-left: 0;
	}
}

.y-auto {
	overflow-y: auto;
}

.toolbar {
	position: relative;

	.toolbar-right {
		position: absolute;
		right: 0;
		top: 0;
	}
}

/deep/ .el-tabs__item {
	width: 100px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	background: #f0f0f0;
	border-radius: 3px 3px 0px 0px;
	color: #666;
	margin-right: 20px;
	padding: 0;

	.el-tabs__header {
		border-bottom: 1px solid #2671cc;
	}
}

/deep/ .el-tabs__item.is-active {
	color: #fff;
	background-color: #2671cc !important;
}

/deep/ .el-tabs__nav-wrap::after {
	background-color: #2671cc;
	height: 1px;
	z-index: 999;
}

/deep/ .el-tabs__active-bar {
	background-color: transparent;
}

.filter-box {
	border-bottom: none !important;
}

.operation-main {
	height: inherit !important;
	overflow: hidden;
}

.red-color {
	color: red;
	margin-right: 5px;
}

.title-style {
	text-align: left;
}
</style>

<style lang="less">
.el-dialog__body {
	max-height: 700px !important;
}
</style>
